


























































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { BvModalEvent } from 'bootstrap-vue';
import { GatewaysApi, NodesApi, SensorsApi } from '@/api';
import Toast from '@/components/display/toast.vue';
import { LastCheckInService } from '@/services/last-check-in-service';
import { Constants } from '@/common/Constants';
import { ApiUtils } from '@/common/ApiUtils';
import ConfirmModal from '@/components/display/confirm-modal.vue';
import SaveCancelButtons from '@/components/elements/buttons/save-cancel-buttons.vue';
@Component({ name: 'TreeChild', components: { SaveCancelButtons, ConfirmModal } })
export default class TreeChild extends Vue {
	@Prop(Object)
	public vertex!: any;

	public lastCheckIn?: number | null = null;

	public isOpen = true;

	public rid = Math.random();
	public deallocatingSensor = false;
	public deallocatingNode = false;
	public deallocatingGateway = false;

	private toast: Toast = new Toast();

	public async created() {
		const lastCheckInResponse = await LastCheckInService.getLastCheckIn(
			this.vertex.type,
			this.vertex.entity.id,
		);
		if (lastCheckInResponse.errorMessage) {
			this.toast.makeToast(
				lastCheckInResponse.errorMessage,
				'Error Getting Last Check-In',
				'danger',
			);
			return;
		}
		this.lastCheckIn = lastCheckInResponse.lastCheckInTimestamp;
	}

	public isTree() {
		return this.vertex.children && this.vertex.children.length;
	}

	public toggle() {
		if (this.isTree()) {
			this.isOpen = !this.isOpen;
		}
	}

	public getOwner() {
		return this.vertex?.entity?.owner ?? this.vertex?.entity?.vat ?? this.vertex?.entity?.tank;
	}

	public getOwnerName() {
		return this.getOwner()?.name ?? this.getOwner()?.label;
	}

	public getProduct() {
		return this.getOwner()?.product ?? { id: -1 };
	}

	public async deallocateSensor(params: { modalId: string }) {
		if (!this.vertex?.entity?.id || this.deallocatingSensor || this.vertex.type !== 'sensor')
			return;
		this.deallocatingSensor = true;
		const sensor = this.vertex.entity;
		try {
			await new SensorsApi().deallocateSensor(sensor.id);
		} catch (e) {
			const error = ApiUtils.handleApiError(
				e,
				`Sensor ${sensor.serialNumber} was not able to be deallocated: ${e}`,
			);
			console.log(error.errorMessage);
			new Toast().makeToast(error.errorMessage, 'Sensor Not Deallocated', 'danger', false);
			this.deallocatingSensor = false;
			return;
		}
		new Toast().makeToast(
			`Successfully Deallocated Sensor ${sensor.serialNumber}`,
			'Sensor Successfully Deallocated',
			'success',
			false,
		);
		this.$emit('reload');
		this.deallocatingSensor = false;
		setTimeout(() => this.$bvModal.hide(params.modalId), 1);
	}

	public async deallocateNode(params: { modalId: string }) {
		if (!this.vertex?.entity?.id || this.deallocatingNode || this.vertex.type !== 'node') return;
		this.deallocatingNode = true;
		const node = this.vertex.entity;
		try {
			await new NodesApi().deallocateNode(node.id);
		} catch (e) {
			const error = ApiUtils.handleApiError(
				e,
				`Node ${node.serialNumber} was not able to be deallocated: ${e}`,
			);
			console.log(error.errorMessage);
			new Toast().makeToast(error.errorMessage, 'Node Not Deallocated', 'danger', false);
			this.deallocatingNode = false;
			return;
		}
		new Toast().makeToast(
			`Successfully Deallocated Node ${node.serialNumber}`,
			'Node Successfully Deallocated',
			'success',
			false,
		);
		this.$emit('reload');
		this.deallocatingNode = false;
		setTimeout(() => this.$bvModal.hide(params.modalId), 1);
	}

	public async deallocateGateway(params: { modalId: string }) {
		if (!this.vertex?.entity?.id || this.deallocatingNode || this.vertex.type !== 'gateway') return;
		this.deallocatingGateway = true;
		const gateway = this.vertex.entity;
		try {
			await new GatewaysApi().deallocateGateway(gateway.id);
		} catch (e) {
			const error = ApiUtils.handleApiError(
				e,
				`Gateway ${gateway.serialNumber} was not able to be deallocated: ${e}`,
			);
			console.log(error.errorMessage);
			new Toast().makeToast(error.errorMessage, 'Gateway Not Deallocated', 'danger', false);
			this.deallocatingGateway = false;
			return;
		}
		new Toast().makeToast(
			`Successfully Deallocated Gateway ${gateway.serialNumber}`,
			'Gateway Successfully Deallocated',
			'success',
			false,
		);
		this.$emit('reload');
		this.deallocatingGateway = false;
		setTimeout(() => this.$bvModal.hide(params.modalId), 1);
	}

	public async deallocate() {
		if (!this.vertex?.entity?.id) return;
		if (['sensor', 'node', 'gateway'].includes(this.vertex.type)) {
			setTimeout(() => this.$bvModal.show(`deallocate-${this.vertex.type}-modal-${this.rid}`), 1);
		}
	}

	public getOwnerType() {
		switch (this.vertex?.entity?.ownerType) {
			case 'waterMeters':
				return Constants.ENTITY_TYPE_WATER_METER;
			case 'waterTanks':
				return Constants.ENTITY_TYPE_WATER_TANK;
			case 'waterMonitors':
				return Constants.ENTITY_TYPE_WATER_MONITOR;
		}
		return (
			this.vertex?.entity?.ownerType ??
			(this.vertex?.entity?.vat ? Constants.ENTITY_TYPE_VAT : Constants.ENTITY_TYPE_FUEL_TANK)
		);
	}

	public getOwnerTypeToRoute() {
		switch (this.getOwnerType()) {
			case Constants.ENTITY_TYPE_MILK_VAT:
				return 'vat';
			case Constants.ENTITY_TYPE_FUEL_TANK:
				return 'tank.view';
			case Constants.ENTITY_TYPE_WATER_METER:
			case Constants.ENTITY_TYPE_WATER_TANK:
			case Constants.ENTITY_TYPE_WATER_MONITOR:
				return 'entity.view';
			case Constants.ENTITY_TYPE_FEED_TANK:
				return 'feedtanks.tankdetail';
		}
	}

	public canDeallocate(): boolean {
		return (
			(!this.vertex.entity || !this.getOwner() || !this.getProduct()) &&
			(this.vertex.type === 'sensor' || this.canDeallocateNode() || this.canDeallocateGateway())
		);
	}

	private canDeallocateNode(): boolean {
		return this.vertex.type === 'node' && this.vertex.children?.length === 0;
	}

	private canDeallocateGateway(): boolean {
		return this.vertex.type === 'gateway' && this.vertex.children?.length === 0;
	}

	private get getWarningTitle(): string {
		if (this.vertex.type === 'gateway' && this.vertex.name == null)
			return 'No gateway found on this transceiver';
		if (this.vertex.type === 'node' && this.vertex.entity.gatewayId == null)
			return 'This node is not allocated to any gateways';
		return '';
	}
}
